<script setup lang="ts">
import { computed } from 'vue'
import { RouterLink } from 'vue-router'
import { guideGroups, type GuideLocale } from './index'
const props = defineProps<{ locale: GuideLocale; base: string }>()
const groups = computed(() => guideGroups(props.locale))
</script>

<template>
  <div class="guide-groups">
    <section v-for="group in groups" :key="group.id" :aria-labelledby="`guide-group-${group.id}`">
      <h2 :id="`guide-group-${group.id}`" class="guide-group-title">{{ group.title }}</h2>
      <ul class="guide-list">
        <li v-for="article in group.articles" :key="article.slug">
          <RouterLink :to="`${base}/${article.slug}`" class="guide-row">
            <span><strong>{{ article.title }}</strong><span class="guide-row-summary">{{ article.summary }}</span></span>
            <svg aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="m9 5 7 7-7 7" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" /></svg>
          </RouterLink>
        </li>
      </ul>
    </section>
  </div>
</template>
